import TermsModal from './terms-modal';

export default TermsModal;
